export const parseCode = (code: number | string ): number | undefined => {
    if (typeof code === 'string') {
      const parsed = parseInt(code);
      return !isNaN(parsed) ? parsed : undefined;
    } else if (typeof code === 'number') {
      return code;
    } else {
      return undefined;
    }
  };

/**
 * Converts a value to a display string for CSV output.
 * If the value is an array, joins items with ', ' (e.g. ['Math', 'Science'] → 'Math, Science').
 * If the value is a string or number, returns it as-is.
 * If the value is null or undefined, returns an empty string.
 */
export const joinIfArray = (value: any): string => {
  if (Array.isArray(value)) {
    return value.join(', ');
  }
  return value ?? '';
};